import { Box, Flex } from "@sidelinesports/fan-design-system";
import type { ApiPlayerDetails } from "../../../../api/index.ts";
import type { ApiPick } from "../../../../api/picks.ts";
import { Dialog } from "../../../../components/index.tsx";
import { PlayerProfile } from "../../../PickYourPlayers/components/index.tsx";
import { useCurrentScoreByPlayer } from "../../hooks/index.ts";
import { useCurrentGamePicks } from "../../hooks/use-current-game-picks.ts";
import { usePlayersQuery } from "../../hooks/use-players.ts";
import { PlayerCard } from "./PlayerCard.tsx";
import styles from "./PlayerCards.module.css";

export const PlayerCardsSection = () => {
  const currentGamePicksQuery = useCurrentGamePicks();
  const playersQuery = usePlayersQuery();
  const { points } = useCurrentScoreByPlayer();

  if (!currentGamePicksQuery.data || !playersQuery.data) {
    return <Box height="20rem" />;
  }

  const picksWithPlayers = matchPicksToPlayers(
    currentGamePicksQuery.data,
    playersQuery.data,
  );

  return (
    <Flex className={styles.cardsContainer} px={16} mx={0}>
      {picksWithPlayers.map(({ pick, player }, index) => (
        <PlayerProfile
          // biome-ignore lint/suspicious/noArrayIndexKey: using pick id causes spurious animations
          key={index}
          player={player}
          trigger={
            <Dialog.Trigger
              as={PlayerCard}
              index={index}
              player={player}
              pick={pick}
              points={points[player.id]?.earned?.total ?? null}
            />
          }
        />
      ))}
    </Flex>
  );
};

function matchPicksToPlayers(picks: ApiPick[], players: ApiPlayerDetails[]) {
  return picks.map((pick) => {
    const player = players.find((p) => p.id === pick.playerId);

    if (!player) {
      throw new Error(`Player with ID ${pick.playerId} not found`);
    }

    return { pick, player };
  });
}
